
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as casev65844qaTCwleavMPW9EC4Bl_oAGcYwIoksYHeFrIAMMeta } from "D:/kandi/kandi-website/src/pages/case.vue?macro=true";
import { default as indexM_451DHOp1bDxy8OCYL4GgoOFK8EBErnx_3mj_45sMnFo_kMeta } from "D:/kandi/kandi-website/src/pages/index.vue?macro=true";
import { default as supportOzVlvIzomW1vKGyr_451DOiea_aFfKm07InVzhJqk9z8sMeta } from "D:/kandi/kandi-website/src/pages/support.vue?macro=true";
import { default as _91id_93uA5DnKWYRrvkAnmj3rR_oxevLxOs4qsV8dZQWwpxVyIMeta } from "D:/kandi/kandi-website/src/pages/news/[id].vue?macro=true";
import { default as brandStory9lIF_fcpWRqCJwGlOXJ560LEndoKDFTbxv9ReFWBFw8Meta } from "D:/kandi/kandi-website/src/pages/brandStory.vue?macro=true";
import { default as indexu6NOIXK7TF_45NOWDlnCtbHbY7bx0N5wK39jjmE6sS0CYMeta } from "D:/kandi/kandi-website/src/pages/news/index.vue?macro=true";
import { default as _91id_93DPNeb4fDl0bsw2_6f_45ay1VBQe4_459_45LmaeHpt_q4ZgPMMeta } from "D:/kandi/kandi-website/src/pages/product/[id].vue?macro=true";
import { default as _91id_93nDmO3Pp99803z6k_45y2OXDQ_45MbJGsAdeoqjvgVSe9mf4Meta } from "D:/kandi/kandi-website/src/pages/dynamics/[id].vue?macro=true";
import { default as indexkwtquYm_45zRDSPB3ZOA0ar43Y8umTs7j2n8fPA5mTVqkMeta } from "D:/kandi/kandi-website/src/pages/product/index.vue?macro=true";
import { default as indexaO0_45JY4nIlmZew1QW_45eQULI9R4Ji50s00xI_45b34rA2sMeta } from "D:/kandi/kandi-website/src/pages/dynamics/index.vue?macro=true";
import { default as component_45stubFjb1HNuIMOhSKoiXVBuCb3mJj9S6feW_8j5vGTMSH0sMeta } from "D:/kandi/kandi-website/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubFjb1HNuIMOhSKoiXVBuCb3mJj9S6feW_8j5vGTMSH0s } from "D:/kandi/kandi-website/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "case",
    path: "/case",
    component: () => import("D:/kandi/kandi-website/src/pages/case.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("D:/kandi/kandi-website/src/pages/index.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("D:/kandi/kandi-website/src/pages/support.vue")
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("D:/kandi/kandi-website/src/pages/news/[id].vue")
  },
  {
    name: "brandStory",
    path: "/brandStory",
    component: () => import("D:/kandi/kandi-website/src/pages/brandStory.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("D:/kandi/kandi-website/src/pages/news/index.vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    component: () => import("D:/kandi/kandi-website/src/pages/product/[id].vue")
  },
  {
    name: "dynamics-id",
    path: "/dynamics/:id()",
    component: () => import("D:/kandi/kandi-website/src/pages/dynamics/[id].vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("D:/kandi/kandi-website/src/pages/product/index.vue")
  },
  {
    name: "dynamics",
    path: "/dynamics",
    component: () => import("D:/kandi/kandi-website/src/pages/dynamics/index.vue")
  },
  {
    name: component_45stubFjb1HNuIMOhSKoiXVBuCb3mJj9S6feW_8j5vGTMSH0sMeta?.name,
    path: "/old-page",
    component: component_45stubFjb1HNuIMOhSKoiXVBuCb3mJj9S6feW_8j5vGTMSH0s
  }
]